import { InventoryOption, CreateInventoryOptionInput } from '../types';
import { OptionFormValues } from '../model';

const emptyToNull = (value?: string | null): string | null => {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
};

export const mapOptionToFormValues = (option?: InventoryOption | null): OptionFormValues => ({
  code: option?.code ?? '',
  name: option?.name ?? '',
  description: option?.description ?? '',
  pricing:
    option?.pricing?.map(row => ({
      year: row.year ?? '',
      make: row.make ?? '',
      model: row.model ?? '',
      modelBase: row.modelBase ?? '',
      cost: row.cost,
    })) ?? [],
});

export const mapFormValuesToInput = (values: OptionFormValues): CreateInventoryOptionInput => ({
  code: values.code.trim(),
  name: values.name.trim(),
  description: emptyToNull(values.description),
  pricing: values.pricing.map(row => ({
    year: emptyToNull(row.year),
    make: emptyToNull(row.make),
    model: emptyToNull(row.model),
    modelBase: emptyToNull(row.modelBase),
    cost: row.cost,
  })),
});
